import * as React from "react";
import { useEffect } from "react";
import styled, { css } from "styled-components";
import { Markdown, Spinner } from "components/common";
import { Alert } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { REPORT_SECTION_ID } from "./ColumnRenderers";
import TraceSection from "./TraceSection";
import useWorkflowRun from "./useWorkflowRun";
const ReportBody = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacings.sm} ${theme.spacings.md};
    background: ${theme.colors.global.background};
    border: 1px solid ${theme.colors.cards.border};
    border-radius: ${theme.spacings.xxs};

    /* No height cap or inner scroll — the box grows to fit the full markdown report. */

    p:first-child,
    h1:first-child,
    h2:first-child,
    h3:first-child {
      margin-top: 0;
    }
  `
);
const ReportSection = ({ entry }) => {
  const sendTelemetry = useSendTelemetry();
  const { data, isLoading, isError, error } = useWorkflowRun(entry.id);
  useEffect(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_RUN_DETAILS_OPENED, {
      app_section: "aiagent-workflows",
      event_details: { workflow_type: entry.type }
    });
  }, [entry.type, sendTelemetry]);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading report\u2026" });
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Failed to load report" }, error instanceof Error ? error.message : "Unknown error");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (data == null ? void 0 : data.state) === "running" && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Spinner, { text: "The agent is working on this run." })), (data == null ? void 0 : data.state) === "failed" && data.error && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "This run did not complete" }, data.error), (data == null ? void 0 : data.final_message) && /* @__PURE__ */ React.createElement(ReportBody, null, /* @__PURE__ */ React.createElement(Markdown, { augment: true, text: data.final_message })), data && /* @__PURE__ */ React.createElement(TraceSection, { entry: data }));
};
const expandedSections = {
  [REPORT_SECTION_ID]: {
    title: "Report",
    // Rendered as an element, not called as a function: `content` is invoked during the parent's
    // render, so hooks in here need a component instance of their own.
    content: (entry) => /* @__PURE__ */ React.createElement(ReportSection, { entry })
  }
};
export default expandedSections;
